require('./dist/scripts/betsol-ng-intl-tel-input');
module.exports = 'betsol.intlTelInput';
